import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "./styles";
import { withStyles } from "@mui/styles";

import SettingsIcon from "@mui/icons-material/Settings";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import SingularityLogo from "shared/dist/assets/images/avatar.png";
import { selectOrganization } from "../../../Services/Redux/actionCreators/organizationActions";
import { userRoles } from "../../../Utils/user";
import {
    organizationSetupStatusesLable,
    organizationSetupStatuses,
} from "../../../Utils/organizationSetup";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";

const OrganizationRaw = ({
    classes,
    orgUuid,
    orgImg,
    orgName,
    orgStatus,
    orgOwner,
    handleClose,
}) => {
    const history = useHistory();
    const { selectedOrganizationUuid, currentUserMail } = useSelector((state) => ({
        selectedOrganizationUuid: state.organization.selectedOrganizationUuid,
        currentUserMail: state.user.email,
    }));
    const dispatch = useDispatch();

    const userRole = currentUserMail === orgOwner ? userRoles.OWNER : userRoles.MEMBER;

    const handleEdit = (event) => {
        event.stopPropagation();
        dispatch(selectOrganization(orgUuid));
        history.push(
            GlobalRoutes.ORGANIZATION_SETUP.path.replace(":orgUuid", selectedOrganizationUuid)
        );
        handleClose();
    };

    const handleSelectOrganization = () => {
        dispatch(selectOrganization(orgUuid));
        if (
            orgStatus === organizationSetupStatuses.PUBLISHED ||
            orgStatus === organizationSetupStatuses.PUBLISH_IN_PROGRESS
        ) {
            history.push(GlobalRoutes.SERVICES.path.replace(":orgUuid", orgUuid));
        } else {
            history.push(GlobalRoutes.ORGANIZATION_SETUP.path.replace(":orgUuid", orgUuid));
        }
    };

    const EditButton = () => {
        return (
            <IconButton onClick={(e) => handleEdit(e)} className={classes.orgEditButton}>
                <SettingsIcon />
            </IconButton>
        );
    };

    const isOrgSelected = selectedOrganizationUuid === orgUuid;

    return (
        <div className={classes.orgNameContainer} onClick={handleSelectOrganization}>
            <Avatar
                aria-label="recipe"
                className={classes.avatar}
                src={orgImg || SingularityLogo}
            />
            <div className={classes.orgNameAndRole}>
                <div className={classes.orgInfo}>
                    <div
                        className={`${classes.orgTitle} ${isOrgSelected && classes.selectedOrganization}`}
                    >
                        {orgName} - {userRole}
                    </div>
                    <div className={classes.orgStatus}>
                        {organizationSetupStatusesLable[orgStatus]}
                    </div>
                </div>
                <div>{userRole === userRoles.OWNER && <EditButton />}</div>
            </div>
        </div>
    );
};

export default withStyles(useStyles)(OrganizationRaw);
